import { useIntl } from 'react-intl';

export const CsvImportInstructions = () => {
    const intl = useIntl();

    return (
        <section
            className='panel panel-default panel-body bg-lightest margin-bottom-15'
            aria-labelledby='csv-import-instructions-title'
            data-testid='csv-import-instructions'
        >
            <h4 id='csv-import-instructions-title' className='margin-top-0 margin-bottom-5'>
                {intl.formatMessage({
                    id: 'intl-msg:ordercom-cloud-frontend.orders.csv-import.instructions.title',
                })}
            </h4>
            <ol className='margin-bottom-0 padding-left-20'>
                <li>
                    {intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.orders.csv-import.instructions.template',
                    })}
                </li>
                <li>
                    {intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.orders.csv-import.instructions.structure',
                    })}
                </li>
                <li>
                    {intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.orders.csv-import.instructions.values',
                    })}
                </li>
                <li>
                    {intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.orders.csv-import.instructions.save-upload',
                    })}
                </li>
            </ol>
        </section>
    );
};
